import { render, staticRenderFns } from "./TransactionStatusComponent.vue?vue&type=template&id=3bfce439"
import script from "./TransactionStatusComponent.vue?vue&type=script&lang=js"
export * from "./TransactionStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports